import * as React from "react"
import styled from "styled-components"
import colors from "theme/colors"

const StyledSVG = styled.svg`
 ${(p) => p.theme.breakpoints.down("sm")} {
    width: 23px;
    height: 23px
}
`

const SvgComponent = ({
  color = colors.black,
}: React.SVGProps<SVGSVGElement>) => {
  const w = 22
  const h = 22
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 22.874 22.884"
    >
      <g
        data-name="FB icon"
      >
        <path
          data-name="Path 567"
          d="M10.322.009c-.241.019-.995.131-1.415.21a11.251 11.251 0 0 0-4.438 2.018 11.411 11.411 0 0 0-2.612 2.779 11.164 11.164 0 0 0 1.374 14.019 11.069 11.069 0 0 0 5.676 3.111A12.163 12.163 0 0 0 14.078 22a11.246 11.246 0 0 0 2.681-1.107A11.538 11.538 0 0 0 19.8 18.31a11.229 11.229 0 0 0-.072-14.353 14.556 14.556 0 0 0-1.292-1.293A11.18 11.18 0 0 0 12 .036a17.324 17.324 0 0 0-1.678-.027m2.1 1.521a8.981 8.981 0 0 1 3.03.937A9.422 9.422 0 0 1 19.91 6.92a9.794 9.794 0 0 1 .9 5.639 8.611 8.611 0 0 1-.957 2.969 8.536 8.536 0 0 1-1.767 2.492 8.781 8.781 0 0 1-1.56 1.289 10.488 10.488 0 0 1-3.366 1.43 9.74 9.74 0 0 1-2.013.105 8.4 8.4 0 0 1-1.917-.107 11.315 11.315 0 0 1-3.708-1.624 13.191 13.191 0 0 1-2.333-2.378 10.7 10.7 0 0 1-1.03-1.913 9.321 9.321 0 0 1-.662-3.738 7.927 7.927 0 0 1 .217-2.146 9.977 9.977 0 0 1 2.572-4.615 9.626 9.626 0 0 1 5.671-2.79 6.856 6.856 0 0 1 1.343-.058 8.169 8.169 0 0 1 1.123.055"
          transform="translate(.251 .26)"
          stroke={color}
          strokeWidth="0.5px"
          fill="#161615"
        />
        <path
          data-name="Path 568"
          d="M329.33 155.9a2.319 2.319 0 0 0-1.443.731 2.538 2.538 0 0 0-.669 1.922c-.02.308-.062 1.4-.062 1.626v.1h-1.327v2.105h1.341l.013 2.276c.007 1.251.019 2.816.027 3.475l.013 1.2.89.013 1.288.019.4.005.005-3.493.005-3.493h1.02c.953 0 1.02 0 1.031-.037a14.268 14.268 0 0 0 .166-1.765l.014-.3h-2.232v-.625a3.745 3.745 0 0 1 .082-1.094.581.581 0 0 1 .492-.442 6.252 6.252 0 0 1 1.325 0c.151.018.275.031.277.029s.209-1.352.232-1.542c.012-.1.023-.24.026-.32l.005-.144-.071-.035a5.185 5.185 0 0 0-1.255-.183c-.392-.029-1.369-.042-1.592-.021"
          transform="translate(-317.748 -151.233)"
          fill="#161615"
        />
      </g>
    </StyledSVG>
  )
}

export default SvgComponent
